import { http, param } from '../utils/http'
import conf from '../config'

export const API_ROOT = `${conf.API_URL}`

const userServices = {
  findUser(payload) {
    var arr = [
      { query: 'pageNumber', val: payload.pageNumber },
      { query: 'pageSize', val: payload.pageSize },
      { query: 'sortField', val: payload.sortField },
      { query: 'sortDirection', val: payload.sortDirection },
      { query: 'search', val: payload.search ? payload.search.trim() : '' },
      { query: 'organizationId', val: payload.organizationId },
    ]
    return http.get(`${API_ROOT}/users${param(arr)}`).then(resp => {
      return resp
    })
  },
  getUser(id) {
    return http.get(`${API_ROOT}/users/${id}`).then(resp => {
      return resp
    })
  },
  updateUser(payload) {
    return http.put(`${API_ROOT}/users/${payload.id}`, payload).then(resp => {
      return resp
    })
  },
  createUser(payload) {
    return http.post(`${API_ROOT}/users`, payload).then(resp => {
      return resp
    })
  },
  resendVerificationEmail(id) {
    return http.put(`${API_ROOT}/users/${id}/invite`).then(resp => {
      return resp
    })
  },
  sendResetPasswordEmail(id) {
    return http.put(`${API_ROOT}/users/${id}/reset-password`).then(resp => {
      return resp
    })
  },
  updateStatus(payload) {
    return http.put(`${API_ROOT}/users/${payload.id}/status/${payload.status}`).then(resp => {
      return resp
    })
  },
  deleteUser(id) {
    return http.delete(`${API_ROOT}/users/${id}`).then(resp => {
      return resp
    })
  },
  createRecall(payload) {

    return http.post(`${API_ROOT}/create`, payload, { requiredAuth: false }).then(resp => {

      //return http.post(`http://127.0.0.1:3000/create`, payload, { requiredAuth: false } ).then(resp => {
      return resp
    })
  },
  updateRecall(payload) {
    //
    return http.put(`${API_ROOT}/update`, payload, { requiredAuth: false }).then(resp => {

      //return http.post(`http://127.0.0.1:3000/create`, payload, { requiredAuth: false } ).then(resp => {
      return resp
    })
  },
  uploadMutlipleFiles(payload) {
    //
    return http.post(`${API_ROOT}/upload`, payload, { requiredAuth: false }).then(resp => {

      return resp
    })
  },
  getRecallList(payload) {
    debugger
    return http.get(`${API_ROOT}/get/allrecalls?userId=${payload.uId}&sortField=${payload.sortField}&sortDirection=${payload.sortDirection}&paginationCount=${payload.pageSize}`, { requiredAuth: false }).then(resp => {

      return resp
    })
  },
  getRecallByUId(payload) {
    //
    return http.get(`${API_ROOT}/get/recallsbyid?RecallId=${payload}`, { requiredAuth: false }).then(resp => {
      //
      return resp
    })
  },
  deleteByGUID(payload) {
    //
    return http.delete(`${API_ROOT}/delete?RecallId=${payload}`, { requiredAuth: false }).then(resp => {

      return resp
    })
  },
  sendResponse(payload) {
    //
    return http.post(`${API_ROOT}/SendMail`, payload, { requiredAuth: false }).then(resp => {

      return resp
    })
  }
}

export default userServices
